import { isDesktop } from 'react-device-detect';
import MainGridController from '../../controllers/grid/MainGridController';
import PromptController from '../../controllers/prompt/PromptController';
import { COMPONENTS } from '../../lib/constants';
import { PromptViewGrid } from './PromptViewGrid';
let scale = isDesktop ? 1 : 2;
export const PromptView = {
	name: COMPONENTS.PROMPT,
	child: true,
	position: {
		x: 0,
		y: 0
	},
	controllers: [
		{
			Controller: PromptController,
			name: 'PromptController',
			config: {
				holder: 'prompt_holder'
			}
		},
		{
			Controller: MainGridController,
			name: 'PromptGridController',
			config: PromptViewGrid
		}
	],
	components: [
		{
			name: 'prompt_holder',
			type: 'Sprite',
			components: [
				{
					name: 'bg',
					type: 'Sprite',
					img: 'external_bonus_bg',
					position: { x: 0, y: 0 },
					scale: { x: scale, y: scale }
					// alpha: 0.9,
				},
				{
					name: 'header',
					type: 'CustomText',
					text: 'FREE_SPIN_HEADER',
					position: { x: 634 / 2, y: 18 },
					anchor: { x: 0.5, y: 0 }
				},
				{
					name: 'PROMPT_TITLE',
					type: 'Text',
					text: 'PROMPT_TITLE',
					position: { x: 634 / 2, y: 90 },
					anchor: { x: 0.5, y: 0 }
				},
				{
					name: 'PROMPT_DESC',
					type: 'Text',
					text: 'PROMPT_DESC',
					position: { x: 634 / 2, y: 120 },
					anchor: { x: 0.5, y: 0 }
				},
				{
					name: 'PROMPT_PRIZE',
					type: 'CustomText',
					text: 'PROMPT_PRIZE',
					position: { x: 634 / 2 + 10, y: 175 },
					anchor: { x: 0.5, y: 0 }
				},
				{
					name: 'PROMPT_PRIZE_DESC',
					type: 'Text',
					text: 'PROMPT_PRIZE_DESC',
					position: { x: 634 / 2, y: 240 },
					anchor: { x: 0.5, y: 0 }
				},
				{
					name: 'PROMPT_PRIZE_DISCOUNT',
					type: 'CustomText',
					text: 'PROMPT_PRIZE_DISCOUNT',
					position: { x: 634 / 2 + 10, y: 245 }
				},
				{
					name: 'PROMPT_PRIZE_DESC_1',
					type: 'Text',
					text: 'PROMPT_PRIZE_DESC_1',
					position: { x: 634 / 2, y: 180 },
					anchor: { x: 0.5, y: 0 }
				},
				{
					name: 'PROMPT_PRIZE_DESC_2',
					type: 'Text',
					text: 'PROMPT_PRIZE_DESC_2',
					position: { x: 634 / 2, y: 180 },
					anchor: { x: 0.5, y: 0 }
				},
				{
					name: 'PROMPT_AMOUNT',
					type: 'CustomText',
					text: 'PROMPT_AMOUNT',
					position: { x: 634 / 2 + 10, y: 304 },
					anchor: { x: 0.5, y: 0 }
				},
				{
					name: 'PROMT_INFO',
					type: 'Text',
					text: 'PROMT_INFO',
					position: { x: 634 / 2, y: 380 },
					anchor: { x: 0.5, y: 0 }
				},
				{
					name: 'PROMPT_YES',
					type: 'ActionButton',
					bg: 'external_bonus_play_now_btn',
					text: 'PROMT_YES',
					position: { x: 180, y: 500 }
				},
				{
					name: 'PROMPT_NO',
					type: 'ActionButton',
					bg: 'external_bonus_play_later_btn',
					text: 'PROMPT_NO',
					position: { x: 452, y: 500 }
				}
			]
		}
	]
};
